import { PageTitle } from "@/components/page-title";
import { Button } from "@/components/ui/button";
import { BankStatement, PropsWithUser } from "@/types";
import { formatDate } from "@/utils/format-date";
import { formatMoney } from "@/utils/format-money";
import { DownloadIcon } from "lucide-react";

type Props = {
  bank_statement: BankStatement;
};

function BankStatementNew({ bank_statement }: PropsWithUser<Props>) {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div className="flex items-center justify-between">
        <PageTitle>Bank statement</PageTitle>
        <Button asChild variant="secondary">
          <a href={bank_statement.download_url}>
            <DownloadIcon />
            Download
          </a>
        </Button>
      </div>
      <div className="space-y-2">
        <div>{bank_statement.bank_account_number}</div>
        <div>
          {formatDate(bank_statement.start_date)} –{" "}
          {formatDate(bank_statement.end_date)}
        </div>
        <div className="font-semibold tabular-nums">
          {formatMoney(bank_statement.opening_balance)} –{" "}
          {formatMoney(bank_statement.closing_balance)}
        </div>
      </div>
    </div>
  );
}

export default BankStatementNew;
